import PropTypes from "prop-types";
import { useSelector } from "react-redux";

export default function PermanentLockBoundary({ children = null, fallBack = null }) {
  const { isPermanentlyLocked } = useSelector(({ application }) => application);

  return isPermanentlyLocked ? fallBack : children;
}

PermanentLockBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  fallBack: PropTypes.element,
};
